import Subtitle from '@/components/ui/subtitle'
import { cn } from '@/lib/utils'
import HeroMesh from '@/components/hero-mesh'

const defaultSteps = [
  {
    num: '01',
    title: 'Discovery Call',
    desc: "Book a free 15-minute consultation. We'll discuss your business goals, current challenges, and growth opportunities. No sales pressure. Just honest advice about what you need.",
  },
  {
    num: '02',
    title: 'Strategic Proposal',
    desc: "Get a custom roadmap & transparent pricing. We'll send a detailed proposal outlining exactly what we'll build, how long it will take, and what it will cost. No surprises, no hidden fees.",
  },
  {
    num: '03',
    title: 'Design & Development',
    desc: "Watch your vision come to life. Our team gets to work building your custom solution. You'll have a dedicated project manager and regular check-ins to ensure we're on track.",
  },
  {
    num: '04',
    title: 'Launch & Growth',
    desc: "Go live and start seeing results. We don't disappear after launch. Whether you choose our VIP Support or project-based work, we're here to help you grow and succeed long-term.",
  },
]

export default function HowWeWork({
  className,
  id,
  title = 'How We Work With You',
  subtitle = 'Proven Process',
  steps = defaultSteps,
}) {
  return (
    <section
      id={id}
      className={cn(
        'hero-mesh relative isolate mt-16 bg-gradient-to-br from-blue-50 via-white to-cyan-50/70 py-16',
        className,
      )}
    >
      <HeroMesh scheme="blue" edgeOnly />
      <div className="relative z-10 mx-auto max-w-screen-xl px-5 md:px-10">
        <div className="flex flex-col gap-10">
          <div className="max-w-3xl">
            <div>
              <Subtitle
                subtitle={subtitle}
                textColor="text-vblue2"
                gradientTextColor="from-vblue2 via-vblue3 to-vcyan1"
              />
              <h2 className="mb-2.5 text-3xl font-bold tracking-tight lg:text-4xl">
                {title}
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
            {steps.map((step, idx) => (
              <div
                key={idx}
                className="group flex flex-col gap-4 sm:flex-row sm:gap-6 lg:gap-8"
              >
                <div className="shrink-0">
                  <span className="bg-gradient-to-br from-vblue2 via-vblue3 to-vcyan1 bg-clip-text text-5xl font-bold tracking-tighter text-transparent lg:text-6xl">
                    {step.num}
                  </span>
                </div>
                <div className="pt-2">
                  <h3 className="mb-2.5 text-xl font-bold tracking-tight text-gray-900 lg:text-2xl">
                    {step.title}
                  </h3>
                  <p className="text-base leading-relaxed text-black lg:text-lg">
                    {step.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
